import { IListModelQueryParamValues } from '@sparelabs/http-client-utils'

export enum DriverMetricType {
  Request = 'request',
  OnTimePerformance = 'onTimePerformance',
}

export interface IDriverMetric {
  type: DriverMetricType
  data: unknown
}

export interface IListDriverMetricsQueryParams extends IListModelQueryParamValues {
  metricTypes: DriverMetricType[]
  fromTs: number
  toTs: number
  driverId: string
  timezone?: string
}

export interface IListDriverMetricsResponse {
  metrics: IDriverMetric[]
}
